import React from 'react'
import { Link } from 'gatsby'
import { Col, Container, Row } from 'react-bootstrap'
import '../../sass/global/footer.scss'

const Footer = () => {
    return (
        <footer>
            <Container>
                <Row className="justify-content-md-center">
                    <Col md={12} className="text-center">
                        <img src="/wowmakers-logo.svg"  className="footer-logo" alt="Digital Experience Studio - WowMakers" width="400" height="64" style={{ marginBottom: '0' }}/>
                    </Col>
                    <Col md={10}>
                        <h2 className="footer-title text-center">
                        We’re an experience design and technology company
					    that helps ambitious brands build their future.
                        </h2>
                    </Col>
                    <Col md={12} className="footer-nav-bottom">
                        <Row>
                            <Col md={4} sm={4} className="tablet-bm mb-5 mb-md-0">
                                <div className="list-wrapper">
                                    <h3 className="title">Digital Services</h3>
                                    <p className="list"><span>Digital Transformation</span></p>
                                    <p className="list"><span>Enterprise & Government Solutions</span></p>
                                    <p className="list"><span>Mobile & Web Applications</span></p>
                                    <p className="list"><span>Artificial Intelligence & Machine Learning</span></p>
                                    <p className="list"><span>User Research</span></p>
                                    <p className="list"><span>User Experience Design</span></p>
                                    <p className="list"><span>User Interface Design</span></p>
                                    <p className="list"><span>UX Audit</span></p>                                    
                                    <p className="copy-right d-none d-sm-block">© {new Date().getFullYear()} ZeroGravity Technologies LLP</p>
                                </div>
                            </Col>
                            <Col md={4} sm={4} className="tablet-bm mb-5 mb-md-0">
                                <div className="list-wrapper middle">
                                    <h3 className="title">Creative Services</h3>
                                    <p className="list"><Link to="/animated-explainer-video/" title="Explainer Videos - WowMakers">Explainer Videos</Link></p>
                                    <p className="list"><Link to="/whiteboard-video-production/" title="Whiteboard Animation - WowMakers">Whiteboard Animation</Link></p>
                                    <p className="list"><Link to="/live-video-production/" title="Live Action Videos - WowMakers">Live Action Videos</Link></p>
                                    <p className="list"><span>Corporate Video</span></p>
                                    <p className="list"><span>Marketing Video</span></p>
                                    <p className="list"><Link to="/explainer-video/faq/" title="Explainer Video FAQ - WowMakers">Explainer Video FAQ</Link></p>
                                    <p className="list"><Link to="/works/videos/" title="Explainer Video Portfolio - WowMakers">Explainer Video Portfolio</Link></p>
                                    <p className="list"><Link to="/blog/explainer-video-software/" title="Explainer Video Software - WowMakers">Explainer Video Software</Link></p>
                                    <p className="list"><Link to="/explainer-video/" title="Explainer Video Guide - WowMakers">Explainer Video Guide</Link></p>                                                                                                            
                                </div>
                            </Col>
                            <Col md={4} sm={4} className="tablet-bm">
                                <div className="list-wrapper">
                                    <h3 className="title">Company</h3>
                                    <p className="list"><Link to="/about/" title="About Team WowMakers">About Team WowMakers</Link></p>
                                    <p className="list"><Link to="/careers/" title="Careers & Job Openings - WowMakers">Careers & Job Openings</Link></p>
                                    <p className="list"><Link to="/blog/" title="UX Design and Video Marketing Blog - WowMakers">Our Blog</Link></p>
                                    <p className="list"><Link to="/case-studies/" title="Project Case Studies - WowMakers">Project Case Studies</Link></p>
                                    <p className="list"><Link to="/contact/" title="Contact Us - WowMakers">Contact Us</Link></p>
                                    <p className="copy-right d-block d-sm-none">© {new Date().getFullYear()} ZeroGravity Technologies LLP</p>
                                </div>
                            </Col>                                                        
                        </Row>
                    </Col>
                    <Col className="sm-wrapper">
                        <Row>
                            <Col className="text-center social-media">
                                <a href="https://www.facebook.com/WowMakers/" className="social-link facebook" title="WowMakers facebook url"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/fb-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>
                            <Col className="text-center social-media">
                                <a href="https://twitter.com/wowmakers/" className="social-link twitter" title="WowMakers Twitter url"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/twitter-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>
                            <Col className="text-center social-media">
                                <a href="https://www.instagram.com/wowmakers/" className="social-link instagram" title="WowMakers Instagram url"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/insta-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>
                            <Col className="text-center social-media">
                                <a href="https://www.linkedin.com/company/wowmakers/" className="social-link linkedin" title="WowMakers LinkedIn url"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/linkedin-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>
                            <Col className="text-center social-media">
                                <a href="https://dribbble.com/wowmakers" className="social-link dribble" title="WowMakers Dribble url"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/dribble-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>
                            <Col className="text-center social-media">
                                <a href="https://www.youtube.com/user/wowmakerschannel/" className="social-link youtube" title="WowMakers Youtube channel"  target="_blank" rel="noreferrer" >
                                    <img src="/footer-social-media-icon/youtube-footer.png" alt="" width="55" height="55" loading="lazy"/>
                                </a>
                            </Col>                                                                                    
                        </Row>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer